<!-- 系统缓存管理-查看/删除缓存 -->
<template>
  <basic-container>
    <el-row style="margin-bottom:10px;">
      <el-input type="input" size="mini" style="width:40%;margin-right:10px" v-model="search" @keyup.enter.native="searchClick" :placeholder="$route.query.CACHE_PRE" clearable></el-input>
      例如：{{ $route.query.CACHE_PRE }}
      <el-button type="primary" size="mini" @click="searchClick" :loading="btnLoading">搜索</el-button>
      <el-button size="mini" @click="reactClick" :loading="btnLoading">清空</el-button>
    </el-row>
    <el-button type="danger" size="mini" @click="delAllClick" :loading="btnLoading">全部删除</el-button>
    <el-button type="danger" size="mini" @click="delListClick" :loading="btnLoading">批量删除</el-button>
    <el-table ref="plxTable" :data="data" tooltip-effect="dark" style="width: 100%;margin-top:10px" v-loading="btnLoading" empty-text="暂无数据">
      <el-table-column type="selection" width="55" fixed="left"></el-table-column>
      <el-table-column label="缓存" align="center" prop="name"></el-table-column>
      <el-table-column label="操作" width="120" fixed="right" align="center">
        <template slot-scope="{ row }">
          <el-button type="text" size="mini" @click="delOneClick(row)">删除</el-button>
          <el-button v-if="$route.query.CACHE_PRE&&$route.query.CACHE_PRE.indexOf('blade:delete_xmrw_password') > -1" type="text" size="mini" @click="showPassword(row)">查看</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="ux-page">
      <footer>
        <el-pagination
          @size-change="sizeChange"
          @current-change="currentChange"
          :current-page="page.currentPage"
          :page-sizes="page.pageSizes"
          :page-size="page.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="page.total">
        </el-pagination>
      </footer>
    </div>
    <el-dialog append-to-body title="查看密码" :visible.sync="validatorDialog" width="430px" class="valid_wrap" top="25vh" center>
      <el-form :model="validForm" :rules="validRules" ref="validForm" size="small">
        <el-form-item label=" " prop="password">
          <el-input placeholder="内容" v-model="validForm.password">
            <template slot="append">
              <el-button @click="copyText" color="primary">复制</el-button>
            </template>
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer" style="align:center">
        <el-button @click="validatorDialog = false" size="small">取 消</el-button>
      </span>
    </el-dialog>
  </basic-container>


</template>
<script>
import { post } from "@/api/table/table";
export default {
  components: {},
  data() {
    return {
      data:[], //展示数据
      page:{
        pageSize: 10,
        currentPage: 1,
        total: 0,
        pageSizes:[5, 10, 20, 50, 100, 200, 500, 1000]
      }, // 分页
      list:[], // 所有数据
      search:"", //检索条件
      btnLoading:true, // loading
      validForm: {password: ''},
      validatorDialog: false
    };
  },
  computed: {},
  methods: {
    //查看密码
    async showPassword(keys) {
      console.log(keys,'keys---keys')
      try {
        let res = await post("/api/blade-system/deleteXmrwAndFlws/getPassword",this.$qs.stringify({key:keys.name}))
        console.log(res,'res---res')
        this.validForm.password = res.data.data || ''
        this.validatorDialog = true
      } catch (error) {

      }
    },
    copyText() {
        this.$Clipboard({
          text: this.validForm.password
        }).then(() => {
          this.$message.success('复制成功')
          this.validatorDialog = false
        }).catch(() => {
          this.$message.error('复制失败')
        });
      },
    // 加载数据
    getList(keys){
      this.data = [];
      this.btnLoading = true;
      this.$set(this.page,"pageSize",10);
      this.$set(this.page,"currentPage",1);
      post("/api/blade-develop/usual/api/getRedisData",{id:this.$route.query.id,keys}).then(res => {
        console.log(res);
        let dataList = [];
        if(res.data.data.data.length){
          res.data.data.data.map(item => {
            dataList.push({name:item})
          })
          let length = this.page.pageSize > dataList.length ? dataList.length : this.page.pageSize;
          for (let index = 0; index < length; index++) {
            const element = dataList[index];
            this.data.push(element);
          }
          this.list = dataList;
        }else{
          this.data = res.data.data.data;
        }
        this.page.total = res.data.data.count;
        this.btnLoading = false;
      })
    },
    // 初始化数据
    init(){
      this.page = {
        pageSize: 10,
        currentPage: 1,
        total: 0,
        pageSizes:[5, 10, 20, 50, 100, 200, 500, 1000]
      }
      this.search = "";
    },
    // 处理分页数据
    setPageSize(){
      this.data = [];
      for (let index = (this.page.currentPage - 1)*this.page.pageSize; index < (this.page.currentPage - 1)*this.page.pageSize+this.page.pageSize; index++) {
        const element = this.list[index];
        this.data.push(element);
      }
      this.btnLoading = false;
    },
    // 选择条数
    sizeChange(pageSize){
      this.btnLoading = true;
      this.page.pageSize = pageSize;
      this.setPageSize();
    },
    // 选择页数
    currentChange(currentPage){
      this.btnLoading = true;
      this.page.currentPage  = currentPage;
      this.setPageSize();
    },
    // 删除单条
    delOneClick(row){
      this.btnLoading = true;
      this.$confirm('此操作将永久删除该缓存, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        post("/api/blade-develop/usual/api/deleteRedisData",{keys:row.name,id:this.$route.query.id}).then(res => {
          this.$message.success("删除成功");
          this.getList();
        })
      }).catch(() => {
        this.btnLoading = false;
      });
    },
    // 批量删除
    delListClick(){
      this.btnLoading = true;
      let arr=this.$refs.plxTable.getCheckboxRecords();
      if(!arr.length) return this.$message.warning("请选择需要删除的数据");
      let keys = arr.map(item => {return item.name});
      this.$confirm('此操作将批量删除选中缓存, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        post("/api/blade-develop/usual/api/deleteRedisData",{keys:keys.join(","),id:this.$route.query.id}).then(res => {
          this.$message.success("删除成功");
          this.getList();
        })
      }).catch(() => {
        this.btnLoading = false;
      });
    },
    // 删除全部
    delAllClick(){
      this.btnLoading = true;
      this.$confirm('此操作将缓存全部删除, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      }).then(() => {
        post("/api/blade-develop/usual/api/deleteRedisData",{keys:-1,id:this.$route.query.id}).then(res => {
          this.$message.success("删除成功");
          this.getList();
        })
      }).catch(() => {
        this.btnLoading = false;
      });
    },
    // 点击搜索
    searchClick(){
      if(this.search == -1) {
        this.search = "";
        return this.$message.error("不可输入-1");
      }
      this.getList(this.search);
    },
    // 点击清空
    reactClick(){
      this.search = "";
      this.getList();
    },
  },
  created() {},
  mounted() {},
  destroyed() {},
  activated() {
    this.getList();
  }
};
</script>
<style lang='scss' scoped>
.ux-page{
  margin-top: 14px;
  // height:32px;
  footer{
    float: right;
  }
}
/deep/.el-table__row{
  height: 30px !important;
}
.valid_wrap {
  /deep/.el-dialog__header {
    padding: 18px 20px 10px;
  }
  /deep/.el-dialog__body {
    padding: 10px 20px;
  }
}
</style>
